import { Box } from '@mui/material';
import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../..';

export type LiProps = StructuredContentDocument<{
  children: StructuredContentDocument;
}>;

export const Li = ({ props }: LiProps) => {
  return (
    <Box
      component="li"
      sx={{
        display: 'flex',
        '&::before': { content: '"\\2022"', pr: 3 },
        '&:not(:last-child)': { marginBottom: 1 },
      }}
    >
      <StructuredContentRenderer doc={props.children} />
    </Box>
  );
};
